import {contactInformation} from "~/config/contactInformation.config";

export const appSettings = {
	contactInformation: contactInformation,
	fallbackCurrency: '?',
}
